const fitForm = document.getElementById("ProductFit");
const carLabel = document.getElementById("catalog-filter-carlabel");
const regionSelect = document.getElementById("RegionSelect_Id");
const makeSelect = document.getElementById("MakeSelect_Id");
const modelSelect = document.getElementById("ModelSelect_Id");
const yearSelect = document.getElementById("YearSelect_Id");
const pathArray = window.location.pathname.replace(/\/$/, "").split("/");
const finderOverlay = document.querySelector(".finder-overlay");
const loadingGraphic = finderOverlay.querySelector(".graphic");
const finderMessage = finderOverlay.querySelector(".message");
const ProductGridContainer = document.getElementById("ProductGridContainer");
const productGridItems = document.querySelectorAll(".grid__item");
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

let formModified = false;
let errorCount = 0;



/**
 * Cookie Utils
 */
const setCookie = (a, b, c, d) => {
  b || (b = "");
  if (!c || isNaN(c)) c = 0.5;
  d || (d = "/");
  var e = new Date();
  e.setTime(e.getTime() + c * 24 * 60 * 60 * 1e3),
    (e = e.toGMTString()),
    a && (document.cookie = a + "=" + b + ";expires=" + e + ";path=" + d);
};
const getCookie = (a) => {
  var b = new RegExp(a + "=[^;]+", "i");
  return a && document.cookie.match(b)
    ? document.cookie.match(b)[0].split("=")[1]
    : "";
};
const deleteCookie = (a, b) => {
  b || (b = "/"), getCookie(a) !== "" && setCookie(a, "", "-1", b);
};

/**
 * Reset functions
 */

const resetLoader = () => {
  finderOverlay.classList.remove("is-active");
  ProductGridContainer.classList.remove("loading");
};

const resetMakeSelect = () => {
  resetLoader();
  makeSelect.innerHTML = "";
  option = new Option("Make", "0");
  makeSelect.appendChild(option);
  makeSelect.disabled = true;
};

const resetModelSelect = () => {
  resetLoader();
  modelSelect.innerHTML = "";
  option = new Option("Model", "0");
  modelSelect.appendChild(option);
  modelSelect.disabled = true;
};

const resetYearSelect = () => {
  resetLoader();
  yearSelect.innerHTML = "";
  option = new Option("Year", "0");
  yearSelect.appendChild(option);
  yearSelect.disabled = true;
};

const resetGrid = () => {
  $('.rack-finder-active').removeClass('no-results');
  productGridItems.forEach((e) => {
    e.classList.remove("hidden");
    e.querySelector(".notes, .product-card__fit-notes").innerHTML = "";
   // alert();
  });
};

/**
 * set up Make options
 */
const setupMakeSelect = () => {
  if (errorCount < 2) {
    resetMakeSelect();
    fetch("https://saris.com/apps/fitguide/fit_guide.php?region=" + regionSelect.value)
      .then(function (response) {
      console.log(response);
        return response.json();
      })
      .then((responseJson) => {
        responseJson.makes.forEach((e) => {
          option = new Option(e.name, e.id);
          makeSelect.appendChild(option);
          makeSelect.focus();
          makeSelect.disabled = false;
          fitForm.style.display = "block";
        });
      })
      .catch(function (e) {
        setupMakeSelect();
        errorCount++;
        console.log(e);
      });
  } else {
    finderMessage.innerHTML =
      "<h3>There was an error loading vehicle data. Please try again later.</h3><p>If the problem persists, please <a href=\"/pages/support-center\">contact us</a> for assistance.</p>";
    ProductGridContainer.classList.add("no-results-custom");
    finderOverlay.classList.add("is-active");
    deleteCookie("saris_userPrefs");
    document.querySelector(".btn-reset").click();
  }
};

/**
 * set up Model options
 */
const setupModelSelect = () => {
  resetModelSelect();
  fetch(
      "https://saris.com/apps/fitguide/fit_guide.php?region=" +
      regionSelect.value +
      "&make=" +
      makeSelect.value
  )
    .then(function (response) {
      //console.log(response);
      return response.json();
    })
    .then((responseJson) => {
      responseJson.models.forEach((e) => {
        option = new Option(e.name, e.id);
        modelSelect.appendChild(option);
        modelSelect.focus();
        modelSelect.disabled = false;
      });
    })
    .catch(function (e) {
      console.log(e);
    });
};

/**
 * set up Year options
 */
const setupYearSelect = () => {
  resetYearSelect();
  fetch( 
      "https://saris.com/apps/fitguide/fit_guide.php?region=" +
      regionSelect.value +
      "&make=" +
      makeSelect.value +
      "&model=" +
      modelSelect.value
  )
    .then(function (response) {
      return response.json();
    })
    .then((responseJson) => {
      responseJson.generations.forEach((e) => {
        var end_year;
        if(e.end_year === null){
          end_year = 'CURRENT';
        }
        else{
          end_year = e.end_year;
        }
        option = new Option(e.start_year+"-"+ end_year, e.id);
        yearSelect.appendChild(option);
        yearSelect.focus();
        yearSelect.disabled = false;
      });
    })
    .catch(function (e) {
      console.log(e);
    });
};

/*** Image path fixes ***/
const stringQ1 = (string)=>{
  //remove white space at the end 
  const arrString = string.split("")
  for(let i = arrString.length -1 ; i>=0 ; i--){
    let char = arrString[i];
    if(char.indexOf(" ") >=0){
     arrString.splice(i,1)
    }else{
      break;
    }
  }
 
  let start =0;
  let end = arrString.length -1;

 
  //add %20
  while(start < end){
    if(arrString[start].indexOf(' ') >=0){
      arrString[start] ="%20"
    }
    start++;
  }
  return arrString.join('');
}

/**
 * Get Vehicle Results
 */
const getMatches = () => {
  currentYear = yearSelect.value == 0 ? userPrefs.year : yearSelect.value;
  ProductGridContainer.classList.add("loading");
  finderOverlay.classList.add("is-active");
 finderMessage.innerHTML = "<h4>" + loadingMessage + "</h4>";

 
  
  fetch(
      "https://saris.com/apps/fitguide/fit_guide.php?region=" +
      regionSelect.value +
      "&make=" +
      makeSelect.value +
     "&model=" +
      modelSelect.value +
      "&generation=" +
      currentYear 
 
  )
    .then(function (response) {    
    console.log(response);
      return response.json();
    })
    .then((responseJson) => {
      $(".image_fit_box .fit_images").html('');
      
        finderMessage.innerHTML = "<h4>" + need_fits + "</h4>";
       let hitchRacks = [];
           if (window.location.href.indexOf("all-racks") > -1 || window.location.href.indexOf('hitch-racks') > -1 || window.location.href.indexOf('racks') > -1) {
         
       let hitchUserPrefs = getCookie("hitch_userPrefs");
           if (hitchUserPrefs == "1_hitch_receivers") {
                 hitchRacks = ['181S','774','883','882','884','178S','4610','4412B','4025F'];
            }
              else if (hitchUserPrefs == "2_hitch_receivers") {
                hitchRacks = ['4620','4662','4430','4026F','4414B','4025HD','4630','4800','4661','4026M','4663','4800R','775','4025MHD','181S','774','883','882','884','178S','4610','4412B','4025F'];  
              }
             $('#hitchId option[hitch_val="'+hitchUserPrefs+'"]').attr('selected','selected');
        }
      
      if (responseJson.fits.length > 0) {
     
        let resultSkus = [];
        let notes = [];
        let fit_image = [];
       
        responseJson.fits.forEach((e) => {      
          resultSkus.push(e.racknumber);
          notes.push(e.notes);
        });
   
           $('.no_fits').hide();
        productGridItems.forEach((e,k) => {
          e.classList.add("hidden");
        const found = resultSkus.some((r) => e.dataset.sku.indexOf(r) >= 0);
          if (found) {
              console.log('here');
            e.classList.remove("hidden");
            if (window.location.href.indexOf("all-racks") > -1 || window.location.href.indexOf('racks') > -1 ) {
            e.classList.add('api_filtered');
            }
            var sku = e.getAttribute('data-sku');   
            var newnotes='';
            var fitImage='';
             var fit_images;
              responseJson.fits.forEach((n,i) => { 
                if(sku.includes(n.racknumber) == true){
                 var notes = responseJson.fits[i].notes;
                  
                   fit_images = responseJson.fits[i].images;
                  if (typeof(notes) != "undefined" && notes.length > 0){
                     newnotes  += '<ul>';
               

                    for (var i = 0; i < notes.length; i++) {
                   newnotes +=  "<li>" + notes[i].note + "</li>";
                    }
                  newnotes +="</ul>";
                                    }
                  
                  fitImage  += '<div class="light-div">';
                  if(fit_images.length){
                  console.log(fit_images[0]);
                     var src_path = fit_images[0].append_url;
                    
                    if (typeof src_path  !== "undefined"){
                   fitImage +=  "<h4>SEE IT ON YOUR VEHICLE</h4><div class='light-box visible_img'><img crossorigin='anonymous' class='light-img' data-num='0' src="+stringQ1(src_path)+"></div>";
                  }
                  }
                    fitImage +='<div class="all-imgs">'
                    for (var i = 0; i < fit_images.length; i++) {
                      var thumb_src_path = fit_images[i].append_url;
                   fitImage +=  "<div class='light-box' class='light-img' style='display:none;'><img crossorigin='anonymous' class='light-img' data-num='"+i+"' src="+stringQ1(thumb_src_path)+"></div>";
                    }
                  fitImage +='</div></div>';
                                    
                }
              });  
            
             var notesContainer = e.querySelector('.product-card__fit-notes');
            var imageContainer = e.querySelector('.fit_images');
                   if (notesContainer && newnotes != '') {
                     $('.notes').text('Fit Notes');
                     $('.notes').show();
                       notesContainer.innerHTML = '';
                        notesContainer.innerHTML += newnotes;
                      newnotes='';
                    }
             if (imageContainer && fit_images.length > 0) {
                       imageContainer.innerHTML = '';
                        imageContainer.innerHTML += fitImage;
                      fitImage='';
                    }
          }
                if (window.location.href.indexOf("all-racks") > -1 || window.location.href.indexOf("hitch-racks") > -1 || window.location.href.indexOf('racks') > -1) {
                 const found2 = hitchRacks.some((r) => e.dataset.sku.indexOf(r) >= 0);
                 // console.log(hitchRacks);
                      if (found2) {
                        e.classList.remove("hidden");
                      }
                }
        });
        finderOverlay.classList.remove("is-active");
        ProductGridContainer.classList.remove("loading");
        ProductGridContainer.classList.remove("no-results");
        
        
      } else {
         if (window.location.href.indexOf("all-racks") > -1 || window.location.href.indexOf("hitch-racks") > -1 || window.location.href.indexOf('racks') > -1) {
          
           productGridItems.forEach((e,k) => {
               e.classList.add("hidden");
                  const found3 = hitchRacks.some((r) => e.dataset.sku.indexOf(r) >= 0);
                  if (found3) {
                    e.classList.remove("hidden");
                    var sku = e.getAttribute('data-sku');
                  }
             });
         }
      
        if (responseJson.FitMessage == "Pending fits") {
             $('.no_fits').show();
          finderMessage.innerHTML = "<h4>" + pendingFitMessage + "</h4>";
        } else {
           $('.no_fits').show();
          finderMessage.innerHTML = "<h4>" + noFitMessage + "</h4>";
        }
        if (window.location.href.indexOf("all-racks") > -1 || window.location.href.indexOf("hitch-racks") > -1 || window.location.href.indexOf('racks') > -1) {
          ProductGridContainer.classList.remove("loading");
            ProductGridContainer.classList.remove("no-results");
          finderOverlay.classList.remove("is-active");
        }
        else{
        ProductGridContainer.classList.remove("loading");
        ProductGridContainer.classList.add("no-results");
        }
         var need_fits = responseJson.no_fit;
          if (typeof(need_fits) != "undefined")
          {
            $('.no_fits h4').html("<span class='verbiage-txt' >Saris has not yet looked at this vehicle for compatibility and cannot guarantee this rack will work with the selected vehicle.</span>");
          $("#product-grid li").removeClass("hidden");
          }
         else{
         
           if(responseJson.fits.length == 0){
              //$('.no_fits').show();
              if(responseJson.status_id == 4){
                 var new_message= "<h4>SORRY! WE HAVEN'T TESTED ANY TRUNK RACKS FOR YOUR VEHICLE YET.</h4><p>This vehicle is still waiting for a trunk-rack fit evaluation. Please check back soon.</p><p>A hitch rack might be a great alternative! Check out our selection of <a href='/collections/hitch-racks'>hitch racks</a></p>";
              }else{
                var new_message = "<h4>SORRY! WE HAVEN'T APPROVED ANY TRUNK RACKS FOR YOUR VEHICLE.</h4><p>Due to our rigorous safety testing process—which involves assessing fit, stability, and compatibility across various vehicle models—this particular vehicle hasn't passed our standards for trunk rack compatibility.</p><p>However, a hitch rack might be a great alternative! Check out our selection of <a href='/collections/hitch-racks'>hitch racks</a></p>";
              }
              $('.no_fits').html(new_message).show();
           }
              }
      }

    })
    .catch(function (e) {
      console.log(e);
    });
};

 
     if (window.location.href.indexOf("all-racks") > -1 || window.location.href.indexOf("hitch-racks") > -1 || window.location.href.indexOf('racks') > -1 && window.location.href.indexOf('trunk-racks') == -1) {
    document
  .getElementById("hitchId")
  .addEventListener("change", function () {
     var hitchRacks = [];
    var hitchVal = $(this).val();
    setCookie( "hitch_userPrefs", hitchVal);
      if (hitchVal == "1_hitch_receivers") {
             hitchRacks = ['181S','774','883','882','884','178S','4610','4412B','4025F'];
        }
          else if (hitchVal == "2_hitch_receivers") {
            hitchRacks = ['4620','4662','4430','4026F','4414B','4025HD','4630','4800','4661','4026M','4663','4800R','775','4025MHD','181S','774','883','882','884','178S','4610','4412B','4025F'];  
      }
    const productGridItems = document.querySelectorAll(".grid__item");
 
     productGridItems.forEach((e,k) => {
       e.classList.add("hidden");
          const found = hitchRacks.some((r) => e.dataset.sku.indexOf(r) >= 0);
          if (found) {
            e.classList.remove("hidden");
            $('.api_filtered').removeClass('hidden');
            var sku = e.getAttribute('data-sku');
          }
     });
  });
     
     }
  $(window).on('load',function(){
     if (window.location.href.indexOf("all-racks") > -1 || window.location.href.indexOf("hitch-racks?racks") > -1 || window.location.href.indexOf('racks') > -1) {
         let hitchUserPrefs = getCookie("hitch_userPrefs");
         $('#hitchId option[value="'+hitchUserPrefs+'"]').attr('selected','selected'); 
     } 
  if(window.location.href.indexOf("hitch-racks?racks") <= -1){
      deleteCookie("hitch_userPrefs");

    }
       })
/**
 * Set Sticky Vehicle
 */
const setStickyVehicle = () => {
  let url = window.location.href.split("?")[0];
  const sort = urlParams.get("sort_by");
  const title = document.title;
  url =
    url +
    "?region=" +
    regionSelect.value +
    "&make=" +
    makeSelect.value +
    "&model=" +
    modelSelect.value +
    "&year=" +
    yearSelect.value;
  sort ? (url += "&sort_by=" + sort) : url;
  formModified
    ? window.history.pushState("", title, url)
    : (window.location.href = url);
  deleteCookie("saris_userPrefs");
  setCookie(
    "saris_userPrefs",
    JSON.stringify({
      region: regionSelect.value,
      make: makeSelect.value,
      model: modelSelect.value,
      year: yearSelect.value,
    }),
    14
  );
};

/**
 * Populate Sticky Vehicle
 */
const populateStickyVehicle = (region = "", make = "", model = "", year = "") => {
  let regionId = "";
  let makeId = "";
  let modelId = "";
  let yearId = "";
  if (typeof region !== "undefined" && region !== "") {
    regionId = region;
    makeId = make;
    modelId = model;
    yearId = year;
  } else {
    regionId = urlParams.get("region");
    makeId = urlParams.get("make");
    modelId = urlParams.get("model");
    yearId = urlParams.get("year");
  }
  let stickyMake = "";
  let stickyModel = "";
  let stickyYear = "";
  document
    .querySelector(".product-grid__sections")
    .scrollIntoView({ behavior: "instant" });
  fetch("https://saris.com/apps/fitguide/fit_guide.php?region=" + regionId)
    .then(function (response) {
      return response.json();
    })
    .then((responseJson) => {
      responseJson.makes.forEach((e) => {
        if (e.id == makeId) {
          stickyMake = e.name;
          getMakeText();
        }
      });
    })
    .catch(function (e) {
      console.log(e);
      setupMakeSelect();
    });
  function getMakeText() {
    fetch(
     "https://saris.com/apps/fitguide/fit_guide.php?region=" + regionId + "&make=" + makeId
    )
      .then(function (response) {
        return response.json();
      })
      .then((responseJson) => {
     responseJson.models.forEach((e) => {
        if (e.id == modelId) {
          stickyModel = e.name;
          getModelText();
        }
      });
      })
      .catch(function (e) {
        console.log(e);
      });
  }
  function getModelText() {
    fetch(
        "https://saris.com/apps/fitguide/fit_guide.php?region=" + regionId + "&make=" + makeId + "&model=" + modelId
    )
      .then(function (response) {
        return response.json();
      })
      .then((responseJson) => {
          responseJson.generations.forEach((e) => {
        if (e.id == yearId) {
             var end_year;
        if(e.end_year === null){
          end_year = 'CURRENT';
        }
        else{
          end_year = e.end_year;
        }
          stickyYear = e.start_year+"-"+end_year;
          setLabel();
        }
      }); 
      })
      .catch(function (e) {
        console.log(e);
      });
  }
  function setLabel() {
    carLabel.querySelector(".text").innerHTML =
      stickyMake +
      " " +
      stickyModel +
      " " +
      stickyYear +
      '  |  <a href="#" class="car-remove" >Change</a>';
    fitForm.style.display = "none";
    carLabel.style.display = "block";
    document
      .querySelector(".car-remove")
      .addEventListener("click", clearVehicle);
  }
  getMatches();
};

/**
 * Clear Vehicle
 */
const clearVehicle = (e) => {
  e.preventDefault();
  carLabel.querySelector(".text").innerHTML = "";
  fitForm.style.display = "block";
  carLabel.style.display = "none";
  deleteCookie("saris_userPrefs");
  window.history.pushState("", "", window.location.href.split("?")[0]);
  resetGrid();
  resetModelSelect();
  resetYearSelect();
  setupMakeSelect();
  $(".fit_notes .product-card__fit-notes").html('');
   $(".image_fit_box .fit_images").html('');
  $('.no_fits').hide();
};

/**
 * On Region Change, set up other selects
 */
document
  .getElementById("RegionSelect_Id")
  .addEventListener("change", function () {
    resetModelSelect();
    resetYearSelect();
    setupMakeSelect();
  });

/**
 * On Make Change, set up other selects
 */
document
  .getElementById("MakeSelect_Id")
  .addEventListener("change", function () {
    resetModelSelect();
    resetYearSelect();
    setupModelSelect();
  });

/**
 * On Model Change, set up years
 */
document
  .getElementById("ModelSelect_Id")
  .addEventListener("change", function () {
    setupYearSelect();
  });

/**
 * On Year change, filter products
 */
document
  .getElementById("YearSelect_Id")
  .addEventListener("change", function () {
    this.blur();
    getMatches();
    formModified = true;
    setStickyVehicle();
  });

/**
 * Utility to delete specific parameter from URL
 */
function removeParams(sParam) {
  var url = window.location.href.split("?")[0] + "?";
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");
    if (sParameterName[0] != sParam) {
      url = url + sParameterName[0] + "=" + sParameterName[1] + "&";
    }
  }
  return url.substring(0, url.length - 1);
}

// if parameters or cookie are present, set up sticky vehicle, otherwise just pull in makes for default region
let year = urlParams.get("year");
let userPrefs = getCookie("saris_userPrefs");

if (typeof userPrefs !== undefined && userPrefs !== "") {
  userPrefs = JSON.parse(userPrefs);
  populateStickyVehicle(userPrefs.region, userPrefs.make, userPrefs.model, userPrefs.year);
} else if (typeof year !== undefined && year !== null) {
  populateStickyVehicle();
} else {
  document.querySelector(".btn-reset").click();
  setupMakeSelect();
}

// set reset button to clear filters
document.querySelector(".btn-reset").addEventListener("click", clearVehicle);

/**
 * Handle sorting
 */

// -----AVAILABLE OPTIONS-------
//  manual
//  price-ascending
//  price-descending
//  title-ascending
//  title-descending
//  created-ascending
//  created-descending
//  best-selling

document
  .getElementById("SortSelect_Id")
  .addEventListener("change", function () {
    const sort = urlParams.get("sort_by");
    if (typeof sort == "undefined") {
      let url = window.location.href.split("?")[0];
      window.open(url + "?sort_by=" + this.value, "_self");
    } else {
      let url = removeParams("sort_by");
      window.open(url + "&sort_by=" + this.value, "_self");
    }
  });

//check if sort_by is in url
if (window.location.href.indexOf("sort_by") > -1) {
  let sort_by = window.location.href.split("sort_by=")[1];
  document.getElementById("SortSelect_Id").value = sort_by;
}
